import React from "react";
import { render } from "react-dom";
import { TransitionMotion, spring } from "react-motion";

const useStyles = {
    field: {
        "width": "100%",
        "height": "56px",
        "borderRadius": "4px",
        "position": "relative",
        "backgroundColor": "rgba(255, 255, 255, 0.3)",
        "transition": "0.3s background-color ease-in-out, 0.3s box-shadow ease-in-out"
      },
      field_hover: {
        "backgroundColor": "rgba(255, 255, 255, 0.45)",
        "boxShadow": "0px 4px 20px 0px rgba(0, 0, 0, 0.05)"
      },
      field_active: {
        "backgroundColor": "#ffffff",
        "boxShadow": "0px 4px 20px 0px rgba(0, 0, 0, 0.2)"
      },
      field_active_input: {
        "padding": "24px 16px 8px 16px"
      },
      field_active_input___label: {
        "top": "4px",
        "opacity": "1",
        "color": "#512da8"
      },
      field_locked: {
        "pointerEvents": "none"
      },
      field_input: {
        "width": "100%",
        "height": "56px",
        "position": "relative",
        "padding": "0px 16px",
        "border": "none",
        "borderRadius": "4px",
        "fontFamily": "\"Gotham SSm A\", \"Gotham SSm B\", sans-serif",
        "fontSize": "16px",
        "fontWeight": "400",
        "lineHeight": "normal",
        "backgroundColor": "transparent",
        "color": "#282828",
        "outline": "none",
        "boxShadow": "0px 4px 20px 0px transparent",
        "transition": "0.3s background-color ease-in-out, 0.3s box-shadow ease-in-out,\n    0.1s padding ease-in-out",
        "WebkitAppearance": "none"
      },
      "field_input___webkit_input_placeholder": {
        "color": "rgba(255, 255, 255, 0.8)"
      },
      "field_input___moz_placeholder": {
        "color": "rgba(255, 255, 255, 0.8)"
      },
      "field_input__ms_input_placeholder": {
        "color": "rgba(255, 255, 255, 0.8)"
      },
      "field_input__moz_placeholder": {
        "color": "rgba(255, 255, 255, 0.8)"
      },
      field_input___label: {
        "position": "absolute",
        "top": "24px",
        "left": "16px",
        "fontFamily": "\"Gotham SSm A\", \"Gotham SSm B\", sans-serif",
        "fontSize": "12px",
        "fontWeight": "600",
        "lineHeight": "24px",
        "color": "#ffffff",
        "opacity": "0",
        "pointerEvents": "none",
        "transition": "0.1s all ease-in-out"
      },
      "field_input___label_error": {
        "color": "#ec392f"
      },
      "field_p_predicted": {
        "position": "absolute",
        "top": "8px",
        "left": "16px",
        "fontFamily": "\"Gotham SSm A\", \"Gotham SSm B\", sans-serif",
        "fontSize": "16px",
        "fontWeight": "400",
        "lineHeight": "24px",
        "color": "#e0e0e0",
        "opacity": "1",
        "pointerEvents": "none"
      }
      
  }

export default class Input extends React.Component {
    constructor(props) {
      super(props);
  
      this.state = {
        active: (props.locked && props.active) || false,
        value: props.value || "",
        error: props.error || "",
        label: props.label || "Label"
      };
    }
  
    changeValue(event) {
      const value = event.target.value;
      this.setState({ value, error: "" });
    }
  
    handleKeyPress(event) {
      if (event.which === 13) {
        this.setState({ value: this.props.predicted });
      }
    }
  
    return() {
      const { active, value, error, label } = this.state;
      const { predicted, locked } = this.props;
      const fieldClassName = `field ${(locked ? active : active || value) &&
        "active"} ${locked && !active && "locked"}`;
  
      return (
        <div className={fieldClassName}>
          {active &&
            value &&
            predicted &&
            predicted.includes(value) && <p className="predicted">{predicted}</p>}
          <input
            id={1}
            type="text"
            value={value}
            placeholder={label}
            onChange={this.changeValue.bind(this)}
            onKeyPress={this.handleKeyPress.bind(this)}
            onFocus={() => !locked && this.setState({ active: true })}
            onBlur={() => !locked && this.setState({ active: false })}
          />
          <label htmlFor={1} className={error && "error"}>
            {error || label}
          </label>
        </div>
      );
    }

}
